const initialState = {
  dishes: [],
};

export default function dishesReducer(state = initialState, action) {
  switch (action.type) {
    case "DISHES_FETCHED": {
      return {
        dishes: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
